import React, { useCallback, useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import { Box, Button, Typography, Select, MenuItem, FormControl, Autocomplete, TextField } from "@mui/material";
import style from "./style";
import { CustomizedRadio } from "../../components/CustomRadio";
import Switch from "@mui/material/Switch";
import DragAndDropInput from "../../components/DragAndDropInput";
import currencySymbolMap from "currency-symbol-map";
import currencyCodes from "currency-codes";
import CustomInput from "../../components/CustomInput";
import { styled } from "@mui/material/styles";
import Modal from "../../components/Modal";
import Stack from "@mui/material/Stack";
import { useForm } from "../../hooks/useForm";
import { accountSettingData } from "../../constants/data";
import { AccountSettingsValidate } from "../../helper/Validation";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import countryList from "react-select-country-list";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { getRegionsByCountry } from "../../utils/regions";

const AccountSettingsPage = ({ handleAccountSetting, handleCompanyDetails, loading, handleUrl, data, handleNewCompany, from, getTaxType,
  tax, payslipData, companyToken, logoUploading = false, faviconUploading = false }) => {
  const [cCode, setCCode] = useState("");
  const [phoneCode, setPhoneCode] = useState("");
  const [phone, setPhone] = useState(data?.cellNumber?.toString());
  const [mobile, setMobile] = useState(data?.phone?.toString());
  const [initialData, setInitialData] = useState("");
  const mobileNumberRef = useRef(null);
  const hasFetchedRef = useRef(false);
  const lastFetchedIdRef = useRef(null);
  const options = countryList().getData();
  const [deskNoti, setDeskNoti] = useState(true);
  const [emailNoti, setEmailNoti] = useState(true);
  const [orders, setOrders] = useState(true);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [isRegionLoading, setIsRegionLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const location = useLocation();
  const { id: routeId, isEditable } = location.state || {};
  const id = routeId || localStorage.getItem("id");

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const [format, setFormat] = useState(data?.payslipFormat?.name === "default" ? "format1" : data?.payslipFormat?.name);
  
  useEffect(() => {
    // Only fetch if we have an id, it's not a new company, and we haven't fetched this id yet
    if (id && from !== "New" && lastFetchedIdRef.current !== id) {
      hasFetchedRef.current = true;
      lastFetchedIdRef.current = id;
      handleCompanyDetails(id);
    }
  }, [id, from]);

  const vatAndGst = "";

  useEffect(() => {
    if (data?.phone) {
      setMobile(data.phone.toString());
      setCCode(data?.country?.dialCode || "");
    }
    if (data?.cellNumber) {
      setPhone(data.cellNumber.toString());
      setPhoneCode(data?.country?.dialCode || "");
    }
  }, [data]);

  useEffect(() => {
    setInitialData(from === "New" ? "" : data);
    setFormat(from === "New" ? "format1" : data?.payslipFormat?.name === "default" ? "format1" : data?.payslipFormat?.name);
    return () => {
      setMobile("");
      setPhone("");
      setInitialData("");
    };
  }, [from, data]);

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor:
            theme.palette.mode === "dark" ? "#177ddc" : "#28AA4A",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,.35)"
          : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));

  const handleOnChanges = (value, country) => {
    setMobile(value);
    setCCode(country?.dialCode);
  };
  const handlePhoneChanges = (value, country) => {
    setPhone(value);
    setPhoneCode(country?.dialCode);
  };

  const updateProfile = {
    companyName: {
      value: initialData?.companyName || "",
      error: "",
      focus: null,
    },
    email: {
      value: initialData?.email || "",
      error: "",
      focus: null,
    },
    phone: {
      value: initialData?.phone || "",
      error: "",
      focus: null,
    },
    address1: {
      value: initialData?.address1 || "",
      error: "",
      focus: null,
    },
    address2: {
      value: initialData?.address2 || "",
      error: "",
      focus: null,
    },
    format: {
      value: initialData?.payslipFormat?.name || format,
      error: "",
      focus: null,
    },
    cellNumber: {
      value: initialData?.cellNumber || "",
      error: "",
      focus: null,
    },
    city: {
      value: initialData?.city || "",
      error: "",
      focus: null,
    },
    state: {
      value: initialData?.state || "",
      error: "",
      focus: null,
    },
    zipCode: {
      value: initialData?.zipCode || "",
      error: "",
      focus: null,
    },
    country: {
      value: initialData?.country || "",
      error: "",
      focus: null,
    },
    region: {
      value: initialData?.region || "",
      error: "",
      focus: null,
    },
    gstNo: {
      value: initialData?.gstNo || "",
      error: "",
      focus: null,
    },
    companyRegNo: {
      value: initialData?.companyRegNo || "",
      error: "",
      focus: null,
    },
    currency: {
      value: initialData?.currency?.label || "",
      error: "",
      focus: null,
    },
    incomeTax: {
      value: initialData?.incomeTax || "",
      error: "",
      focus: null,
    },
  };

  useEffect(() => {
    const currencies = currencyCodes.codes().map((code) => {
      const currency = currencyCodes.code(code);
      return {
        value: currency.code,
        label: `${currencySymbolMap(currency.code)} - ${currency.currency}`,
      };
    });

    setCurrencyOptions(currencies);
  }, []);

  const handleCurrencyChange = (event, newValue) => {
    setSelectedCurrency(newValue);
  };

  const loadRegions = useCallback(async (selectedCountry) => {
    if (!selectedCountry) {
      setRegionOptions([]);
      return;
    }

    setIsRegionLoading(true);
    try {
      const regions = await getRegionsByCountry(selectedCountry);
      setRegionOptions(regions);
    } catch (error) {
      setRegionOptions([]);
    } finally {
      setIsRegionLoading(false);
    }
  }, []);


  useEffect(() => {
    if (currencyOptions.length > 0 && initialData?.currency?.label) {
      const selected = currencyOptions.find(
        (option) => option.value === initialData.currency
      );
      setSelectedCurrency(selected);
    }
  }, [data?.currency, currencyOptions]);

  const handleAccountData = (user) => {

    if (from !== "New" && initialData?._id === id) {
      handleAccountSetting(
        user,
        initialData,
        phone,
        phoneCode,
        deskNoti,
        emailNoti,
        orders,
        vatAndGst,
        selectedCurrency,
        format
      );
    } else {
      handleNewCompany(
        user,
        initialData,
        phone,
        phoneCode,
        deskNoti,
        emailNoti,
        orders,
        vatAndGst,
        selectedCurrency,
        format
      );
    }
  };

  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    accountSettingData,
    AccountSettingsValidate,
    handleAccountData
  );

  const { companyName, email, addressLine1, addressLine2, city, states, zipCode, country, region, companyRegistrationNumber, number, incomeTax } = state;

  const selectedCountry = country?.value || initialData?.country || "";
  const selectedRegion = region?.value || "";
  const displayedRegionOptions =
    selectedRegion && !regionOptions.includes(selectedRegion)
      ? [selectedRegion, ...regionOptions]
      : regionOptions;

  const handleCountryChange = (event) => {
    const nextCountry = event.target.value;
    handleChange("country", nextCountry);
    handleChange("region", "");
    getTaxType(nextCountry);
  };

  useEffect(() => {
    loadRegions(selectedCountry);
  }, [loadRegions, selectedCountry]);

  // Update form fields when data is loaded (only once when data first arrives)
  const dataLoadedRef = useRef(false);
  useEffect(() => {
    if (data && typeof data === "object" && Object.keys(data).length > 0 && from !== "New" && !dataLoadedRef.current) {
      dataLoadedRef.current = true;
      // Map API response fields to form fields
      if (data.companyName) handleChange("companyName", data.companyName);
      if (data.email) handleChange("email", data.email);
      if (data.address1) handleChange("addressLine1", data.address1);
      if (data.address2) handleChange("addressLine2", data.address2);
      if (data.city) handleChange("city", data.city);
      if (data.state) handleChange("states", data.state);
      if (data.zipCode) handleChange("zipCode", data.zipCode);
      if (data.country) handleChange("country", data.country);
      if (data.region) handleChange("region", data.region);
      if (data.companyRegNo) handleChange("companyRegistrationNumber", data.companyRegNo);
      if (data.gstNo) handleChange("number", data.gstNo);
      if (data.vatNo) handleChange("number", data.vatNo);
      if (data.incomeTax) handleChange("incomeTax", data.incomeTax);
      
      // Set notification switches
      if (data.isDesktopNoti !== undefined) setDeskNoti(data.isDesktopNoti);
      if (data.isEmailNoti !== undefined) setEmailNoti(data.isEmailNoti);
      if (data.isOreders !== undefined) setOrders(data.isOreders);
    }
    
    // Reset the ref when data changes or component unmounts
    return () => {
      if (!data || Object.keys(data).length === 0) {
        dataLoadedRef.current = false;
      }
    };
  }, [data, from]);
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate("/dashboard/companyList");
  };
  const handleNavigate = (item) => {
    navigate("/dashboard/additionalInformation", { state: { item: from === "New" ? "" : item, isEditable, companyToken } })
  }

  return (
    <>
      <Box
        px="15px"
        mt={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap={{ xs: "wrap" }}
        gap={"10px"}
      >
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>
            {from === "New" ? "Add New Company" : "Account Settings"}
          </Typography>
        </Box>
        {!(from === "New") && (
          <Box sx={style.headerContainerRight}>
            {!(from === "New") && (
              <Button
                variant="contained"
                type="submit"
                color="success"
                sx={style.additionalButtons}
                onClick={() => handleNavigate()}
              >
                Additional Informations
              </Button>
            )}
          </Box>
        )}
      </Box>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container>
          <Grid item xs={12} lg={11.7} sx={style.gridbox}>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Company Name</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="companyName"
                  error={companyName?.error}
                  name="companyName"
                  value={companyName?.value}
                  defaultValue={updateProfile?.companyName?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="companyName"
                  readOnly={!isEditable && from !== "New"}
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Email</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  error={email?.error}
                  name="email"
                  defaultValue={updateProfile?.email?.value}
                  value={email?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="email"
                  readOnly={!isEditable && from !== "New"}
                />
              </Box>
              <Box sx={style.inputBox}>
                <FormControl
                  fullWidth
                  sx={style.mobileGrid}
                >
                  <Typography sx={style.inputText}>Phone Number</Typography>

                  <PhoneInput
                    country={phoneCode || "za"}
                    enableSearch={true}
                    defaultValue={phoneCode || data?.cellNumber?.value?.toString()}
                    value={phone}
                    name="phone"
                    onChange={(value, country) =>
                      handlePhoneChanges(value, country)
                    }
                    readOnly={!isEditable && from !== "New"}
                    onFocus={handleFocus}
                    disabled={!isEditable && from !== "New"}
                    ref={mobileNumberRef}
                    sx={style.mobile}
                    inputProps={{
                      style: {
                        height: "1em",
                        borderRadius: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Address Line 1</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="addressLine1"
                  error={addressLine1?.error}
                  readOnly={!isEditable && from !== "New"}
                  name="addressLine1"
                  value={addressLine1?.value}
                  defaultValue={updateProfile?.address1?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="addressLine1"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Address Line 2</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="addressLine2"
                  error={addressLine2?.error}
                  name="addressLine2"
                  value={addressLine2?.value}
                  readOnly={!isEditable && from !== "New"}
                  defaultValue={updateProfile?.address2?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="addressLine2"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>City</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="city"
                  error={city?.error}
                  name="city"
                  value={city?.value}
                  defaultValue={updateProfile?.city?.value}
                  onChange={handleChange}
                  readOnly={!isEditable && from !== "New"}
                  onFocus={handleFocus}
                  autoComplete="city"
                />
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>State/Province</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="states"
                  error={states?.error}
                  name="states"
                  value={states?.value || ""}
                  defaultValue={updateProfile?.state?.value}
                  readOnly={!isEditable && from !== "New"}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="states"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Zip Code</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="zipCode"
                  error={zipCode?.error}
                  name="zipCode"
                  value={zipCode?.value || ""}
                  defaultValue={updateProfile?.zipCode?.value || ""}
                  onChange={handleChange}
                  readOnly={!isEditable && from !== "New"}
                  onFocus={handleFocus}
                  autoComplete="zipCode"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Country</Typography>
                <Select
                  value={state.country?.value || initialData?.country || ""}
                  onChange={handleCountryChange}
                  name="country"
                  sx={style.hoursInput}
                  onFocus={handleFocus}
                  error={country.error}
                  disabled={!isEditable && from !== "New"}
                  displayEmpty
                >
                  <MenuItem disabled value="">
                    Select
                  </MenuItem>

                  {options.map((country, index) => (
                    <MenuItem
                      key={index}
                      sx={style.dropDownMenu}
                      readOnly={!isEditable && from !== "New"}
                      value={country.label}
                    >
                      {country.label}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Region</Typography>
                <Select
                  value={selectedRegion}
                  onChange={(event) => handleChange("region", event.target.value)}
                  name="region"
                  sx={style.hoursInput}
                  onFocus={handleFocus}
                  error={region?.error}
                  disabled={!selectedCountry || isRegionLoading || (!isEditable && from !== "New")}
                  displayEmpty
                >
                  <MenuItem disabled value="">
                    {isRegionLoading ? "Loading regions..." : "Select"}
                  </MenuItem>
                  {displayedRegionOptions.map((regionName) => (
                    <MenuItem
                      key={regionName}
                      sx={style.dropDownMenu}
                      value={regionName}
                    >
                      {regionName}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={{ ...style.inputText, marginBottom: "6px" }}>Currency</Typography>
                <Autocomplete
                  options={currencyOptions}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search currency"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  value={
                    selectedCurrency ||
                    currencyOptions.find(
                      (option) => option.value === initialData?.currency?.value
                    ) ||
                    null
                  }
                  onChange={handleCurrencyChange}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  readOnly={!isEditable && from !== "New"}
                  sx={{
                    "& .MuiAutocomplete-listbox": {
                      maxHeight: "200px",
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />


              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>
                  Company Registration Number
                </Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  readOnly={!isEditable && from !== "New"}
                  id="companyRegistrationNumber"
                  error={companyRegistrationNumber?.error}
                  name="companyRegistrationNumber"
                  value={companyRegistrationNumber?.value}
                  defaultValue={updateProfile?.companyRegNo?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="companyRegistrationNumber"
                />
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>
                  {tax?.taxType || "VAT"}
                </Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="number"
                  error={number?.error}
                  readOnly={!isEditable && from !== "New"}
                  name="number"
                  defaultValue={updateProfile?.vatNo?.value || updateProfile?.gstNo?.value}
                  value={number?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="number"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Income Tax Number</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  readOnly={!isEditable && from !== "New"}
                  id="incomeTax"
                  error={incomeTax?.error}
                  name="incomeTax"
                  value={incomeTax?.value}
                  defaultValue={updateProfile?.incomeTax?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="incomeTax"
                />
              </Box>
              <Box sx={style.inputBox}></Box>
            </Box>
            <Box sx={style.uploadSection}>
              <Typography sx={style.uploadText}>Upload Logo Image</Typography>
              <DragAndDropInput
                handleUrl={(data) => handleUrl(data, "logo")}
                isFrom={initialData?.logo ? "edit" : ""}
                profileImg={initialData?.logo}
                uploading={logoUploading}

              />
            </Box>
            <Box sx={style.uploadSection}>
              <Typography sx={style.uploadText}>Favicon</Typography>
              <DragAndDropInput
                handleUrl={(data) => handleUrl(data, "favicon")}
                isFrom={initialData?.favicon ? "edit" : ""}
                profileImg={initialData?.favicon}
                uploading={faviconUploading}
              />
            </Box>
          </Grid>
          <Typography sx={style.gridText}>Other Settings</Typography>
          <Grid item xs={12} lg={11.7} sx={style.gridbox}>
            <Box sx={style.leaveSection}>
              <Box sx={style.switchSection}>
                <Box sx={style.switchKeyText}>
                  <Typography sx={style.switchContent}>
                    Show Desktop Notification
                  </Typography>
                </Box>
                <Box>
                  {" "}
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch
                      checked={deskNoti}
                      onChange={(e) => {
                        setDeskNoti(e.target.checked);
                      }}
                      disabled={!isEditable && from !== "New"}
                    />
                  </Stack>
                </Box>
              </Box>
              <Box sx={style.switchSection}>
                <Box sx={style.switchKeyText}>
                  <Typography sx={style.switchContent}>
                    Show Email Notification
                  </Typography>
                </Box>
                <Box>
                  {" "}
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch
                      checked={emailNoti}
                      onChange={(e) => {
                        setEmailNoti(e.target.checked);
                      }}
                      disabled={!isEditable && from !== "New"}
                    />
                  </Stack>
                </Box>
              </Box>
              <Box sx={style.switchSection}>
                <Box sx={style.switchKeyText}>
                  <Typography sx={style.switchContent}>Show Orders</Typography>
                </Box>
                <Box>
                  {" "}
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch
                      checked={orders}
                      onChange={(e) => {
                        setOrders(e.target.checked);
                      }}
                      disabled={!isEditable && from !== "New"}
                    />
                  </Stack>
                </Box>
              </Box>
            </Box>
          </Grid>

          <Typography sx={style.gridText}>Select Payslip Format</Typography>
          <Grid item xs={12} lg={11.7} sx={style.gridCheckbox}>
            {payslipData.map((item, index) => (
              <Box sx={style.payslipSection} key={index}>
                <CustomizedRadio
                  handleChange={(val) => {
                    setFormat(val);
                  }}
                  value={format}
                  defaultChecked={format}
                  radioLabel={[{ label: item?.name, value: item?.value }]}

                />

                <Box sx={{ ...style.imgSection, cursor: "pointer" }} onClick={() => handleOpen(item?.format)}                >
                  <img src={item?.format} alt="" width="100%" height="100%" />
                </Box>
              </Box>
            ))}
          </Grid>

          <Box sx={style.mainBoxes}>
            <Box sx={style.createJob}>
              {(from === "New" || isEditable) &&
                <LoadingButton
                  loading={loading || logoUploading || faviconUploading}
                  variant="contained"
                  type="submit"
                  color="success"
                  sx={style.jobButtons}
                  disabled={(!isEditable && from !== "New") || logoUploading || faviconUploading}
                >
                  {logoUploading || faviconUploading ? "Uploading..." : "Save Changes"}
                </LoadingButton>}
            </Box>
            <Box sx={style.createJob}>
              {(from === "New" || isEditable) && <Button
                variant="contained"
                sx={style.cancelButtons}
                onClick={() => handleNavigateBack()}
                disabled={!isEditable && from !== "New"}
              >
                Cancel
              </Button>}
            </Box>
          </Box>
        </Grid>
      </form>

      <Modal open={open} setOpen={setOpen} sx={style.modal} title={""}>
        <Box sx={style.modalContent}>
          <img src={selectedImage} alt="Selected Format" style={{ width: "100%", height: "100%" }} />
        </Box>
      </Modal>

    </>
  );
};

export default AccountSettingsPage;
